<template>
  <div>
    <!--  top-header-->
   <div class="header-position">
     <div class="black">
       <div class="mx-11">
         <v-row>
           <v-col class="d-flex align-center" cols="6">
             <div>

             </div>
           </v-col>
           <v-col :class="this.$i18n.locale==='pr'?'text-left':'text-right'" cols="6">
             <div class="d-flex justify-end align-center">
               <form style="display: flex; position: relative" id="demo-2">
                 <input type="search" placeholder="Search">
                 <v-icon style="position: absolute;top: 10px;right: 6px;" color="warning">mdi-magnify</v-icon>
               </form>
               <v-btn small class="mx-4" depressed color="warning">
                 <p class="ma-0">
                   <v-icon>mdi-account-check</v-icon>
                   ورود
                 </p>
               </v-btn>
               <v-menu offset-y>
                 <template v-slot:activator="{ on, attrs }">
                   <v-btn text
                          color="warning"
                          v-bind="attrs"
                          v-on="on"
                   >
                     <h5 class="gray--text">زبان : </h5> <h5 class="warning--text"> {{ flag[selectedFlag] }} </h5>
                   </v-btn>
                 </template>
                 <div class="white d-flex flex-column">
                   <v-btn @click="changeLanguage(i)" class="my-2" v-for="(item,i) in flag" :key="i" text>
                     {{ item }}
                   </v-btn>
                 </div>
               </v-menu>
             </div>
           </v-col>
         </v-row>
       </div>
     </div>
     <!--    header-->
     <div style="height:80px" class="header-color pt-2">
       <div class="mx-6">
         <v-row :class="[this.$i18n.locale=='en'?'flex-direction-row-reverse':'']">
           <v-col class="text-center" style="cursor: pointer;" cols="2" @click="$router.push('/')">
             <img v-if="this.$i18n.locale==='en'" width="280" src="@/assets/eng_logo.png" alt="icon">
             <img v-else width="280" src="@/assets/pr_logo.png" alt="icon">

           </v-col>
           <v-col  class="d-flex align-center justify-center" cols="10">
             <div
                 v-for="(item,i) in headerItems.links"
                 :key="i"
                 class="d-flex justify-center align-center mx-3"
             >
               <v-menu class="header-color"  v-if="item.type==='sublayer'"
                       min-width="200"
                       transition="scroll-y-transition"
                       tile
                       open-on-hover
                       offset-y
                       left
               >
                 <template v-slot:activator="{ on, attrs }">
                   <v-btn text

                          v-bind="attrs"
                          v-on="on"
                   >
                     <h6 class="font-weight-bold">{{item.name}}</h6>
                     <v-icon color="white" size="3px">mdi-chevron-down</v-icon>
                   </v-btn>
                 </template>
                 <div class="header-color  d-flex flex-column mt-3">
                   <div class="menu-item font-weight-bold d-flex justify-center align-center py-3 text-center"
                        :style="{'border-bottom':i+1 ===item.subDomain.length? '4px solid #FCC300':'1px solid #AFAFAF'}"
                        v-for="(sub,i) in item.subDomain" :key="i">
                     <router-link class="text-decoration-none px-3 white--text font-weight-bold" :to="sub.route">
                       {{sub.name}}
                     </router-link>
                   </div>
                 </div>
               </v-menu>
               <router-link class="product-link" v-else  :to="item.route">
                 <h6 class="font-weight-bold">{{ item.name }}</h6>
               </router-link>
             </div>

           </v-col>
         </v-row>
       </div>
     </div>
   </div>
    <TopSlider/>
  </div>
</template>

<script>
import Home from "../Home/Home";
import TopSlider from "../Home/components/TopSlider";

export default {
  name: "sageHeader",
  components: {TopSlider, Home},
  data() {
    return {
      expand: false,
      selectedFlag: 0,
      flag: [
        'ir',
        'en',
        'ar'
      ],

headerItems:[
  {
    name:'صفحه اصلی',
    type:'single',
    route:'/',
    subDomain:[]
  },
  {
    name:'محصولات',
    type:'sublayer',
    route:'',
    subDomain: [
      {
        name:'شیشه فلوت',
        route:''
      },
      {
        name:'صنایع جانبی',
        route:''
      },
      {
        name:'بلوک سبک اتوکلاو شده',
        route:''
      },
      {
        name:'ملات‌خشک و چسب های ساختمانی',
        route:''
      },
      {
        name:'آجر سیلیکان',
        route:''
      },
      {
        name:'کربنات سدیم',
        route:''
      },
      {
        name:'ماسه ریخته‌گری',
        route:''
      },
      {
        name:'مواد اولیه',
        route:''
      },

    ]
  },
  {
    name:'پروژه ها',
    type:'single',
    route:'projects',
    subDomain:[]
  },
  {
    name:'رویداد و نمایشگاه‌ها',
    type:'single',
    route:'projects',
    subDomain:[]
  },
  {
    name:'مدیریت',
    type:'single',
    route:'management',
    subDomain:[]
  },
    {
    name:'درباره ما',
    type:'sublayer',
    route:'',
    subDomain:[
      {
        name:'معرفی مجموعه',
        route:'about-ardakan'
      },
      {
        name:'مدیریت و هیئت‌مدیره',
        route:'management'
      },
      {
        name:'گواهینامه‌ها و افتخارات',
        route:'about-ardakan'
      },
      {
        name:'صادرات',
        route:''
      },
    ]
  },
  {
    name: 'مسئولیت های اجتماعی',
    route: 'social-responsibilities',
    type:'single',

    subDomain:[]
  },
    {
    name:'اخبار',
    type:'sublayer',
    route:'',
    subDomain:[
      {
        name:'رویداد‌ها و نمایشگاه ها',
        route:'show-place'
      },
      {
        name:'پروژه ها',
        route:'projects'
      },
      {
        name:'مقالات',
        route:'news'
      },
      {
        name: 'مسئولیت های اجتماعی',
        route: 'social-responsibilities'
      },
    ]
  },
  //   {
  //   name:'دعوت به همکاری',
  //   type:'sublayer',
  //   route:'',
  //   subDomain:[
  //     {
  //       name:'فرم استخدام',
  //       route:'employment-form'
  //     },
  //     {
  //       name:'فرم تأمین‌کنندگان',
  //       route:'suppliers-form'
  //     },
  //     {
  //       name:'مزایده و مناقصه',
  //       route:''
  //     }
  //   ]
  // },
  //   {
  //   name:'تماس با ما',
  //   type:'single',
  //   route:'contact-us',
  //   subDomain:[]
  // },

],

    }
  },
  methods: {
    changeLanguage(i) {
      this.selectedFlag = i;
      if (this.selectedFlag === 0) {
        this.$i18n.locale = 'pr'
      }
      if (this.selectedFlag === 1) {
        this.$i18n.locale = 'en'
      }
      if (this.selectedFlag === 2) {
        this.$i18n.locale = 'ar'
      }
    },
  }
}
</script>

<style scoped>
.header-position {
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 99999;
}
h6{
  color: white;
}
.header-color{
background: rgba(0, 0, 0, 0.80);;

  color: white;
}
.menu-item{
  color: white;
  cursor: pointer;
}
.menu-item:hover{
  background: #0846be;
}
.product-link {
  color: black;

  text-decoration: none;
  margin: 0 25px;
}

.product-link:hover {
  border-bottom: 2px solid #F2C303;
  /*transition: all .6s;*/
}

input {
  outline: none;
}

input[type=search] {
  -webkit-appearance: textfield;
  -webkit-box-sizing: content-box;
  font-family: inherit;
  font-size: 100%;
}

input::-webkit-search-decoration,
input::-webkit-search-cancel-button {
  display: none;
}


input[type=search] {
  z-index: 99999;
  color: #F2C303;

  padding: 9px 10px 9px 32px;
  width: 55px;

  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0;

  -webkit-transition: all .5s;
  -moz-transition: all .5s;
  transition: all .5s;
}

input[type=search]:focus {
  width: 200px;

  border-color: #F2C303;

  -webkit-box-shadow: 0 0 5px rgba(109, 207, 246, .5);
  -moz-box-shadow: 0 0 5px rgba(109, 207, 246, .5);
  box-shadow: 0 0 5px rgba(109, 207, 246, .5);
}

input:-moz-placeholder {
  color: #F2C303;
}

input::-webkit-input-placeholder {
  color: #F2C303;
}

/* Demo 2 */
#demo-2 input[type=search] {
  width: 15px;
  padding-left: 10px;
  color: transparent;
  cursor: pointer;
}

#demo-2 input[type=search]:hover {

}

#demo-2 input[type=search]:focus {
  width: 200px;
  height: 20px;
  margin-top: 8px;
  margin-bottom: 8px;
  padding-left: 32px;
  color: #000;
  background-color: #fff;
  margin-right: 9px;
  padding-right: 9px;
  cursor: auto;
}

#demo-2 input:-moz-placeholder {
  color: transparent;
}

#demo-2 input::-webkit-input-placeholder {
  color: transparent;
}
</style>